import { useState } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    location: '',
    cropType: '',
    area: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://n8n.readdy.ai/webhook/c9c4b8a4-8b7e-4c8a-9d2e-3f1a5b6c7d8e', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          location: '',
          cropType: '',
          area: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gray-50" data-contact-section>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            お見積り・ご相談
          </h2>
          <div className="w-24 h-1 bg-[#4CAF50] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            散布代行サービスに関するお見積りやご相談は、下記フォームまたはお電話にてお気軽にお問い合わせください。<br />
            現地調査も無料で承っております。
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* お問い合わせフォーム */}
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">お問い合わせフォーム</h3>
            
            {submitStatus === 'success' && (
              <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                <p className="text-green-800">お問い合わせありがとうございます。担当者より3営業日以内にご連絡いたします。</p>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-800">送信に失敗しました。お手数ですが、お電話にてお問い合わせください。</p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    お名前 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4CAF50] focus:border-transparent"
                    placeholder="山田太郎"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    電話番号 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4CAF50] focus:border-transparent"
                    placeholder="090-1234-5678"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  メールアドレス <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4CAF50] focus:border-transparent"
                  placeholder="example@email.com"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    圃場所在地 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4CAF50] focus:border-transparent"
                    placeholder="佐賀県○○市○○町"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    作物種類 <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="cropType"
                    value={formData.cropType}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4CAF50] focus:border-transparent pr-8"
                  >
                    <option value="">選択してください</option>
                    <option value="水稲">水稲</option>
                    <option value="麦">麦</option>
                    <option value="大豆">大豆</option>
                    <option value="野菜">野菜</option>
                    <option value="果樹">果樹</option>
                    <option value="その他">その他</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  圃場面積（概算）
                </label>
                <input
                  type="text"
                  name="area"
                  value={formData.area}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4CAF50] focus:border-transparent"
                  placeholder="例：5ha、50a など"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  ご相談内容・ご要望
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4CAF50] focus:border-transparent resize-none"
                  placeholder="散布時期、使用農薬、その他ご要望などをお聞かせください（500文字以内）"
                />
                <p className="text-sm text-gray-500 mt-1">{formData.message.length}/500文字</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting || formData.message.length > 500}
                className="w-full px-6 py-4 bg-[#4CAF50] text-white rounded-lg hover:bg-[#45a049] transition-colors font-semibold text-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? '送信中...' : 'お見積り依頼・相談する'}
              </button>
            </form>
          </div>

          {/* 拠点情報 */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">お電話でのご相談</h3>
              <p className="text-gray-600 mb-6">受付時間：平日9:00〜17:00</p>
              
              <div className="space-y-6">
                <div className="border-l-4 border-[#4CAF50] pl-4">
                  <h4 className="font-bold text-gray-900 mb-2">IDS佐賀教習所</h4>
                  <p className="text-sm text-gray-600 mb-2">株式会社アイテム</p>
                  <p className="text-sm text-gray-600 mb-2">対応エリア：佐賀県全域・福岡県筑後地区</p>
                  <div className="flex items-center mb-1">
                    <i className="ri-phone-line mr-2 text-[#4CAF50]"></i>
                    <a href="tel:0952-71-9855" className="text-lg font-bold text-[#4CAF50] hover:text-[#45a049] cursor-pointer">
                      0952-71-9855
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-mail-line mr-2 text-gray-400"></i>
                    <a href="mailto:saga@ids-group.jp" className="text-sm text-gray-600 hover:text-[#4CAF50] cursor-pointer">
                      saga@ids-group.jp
                    </a>
                  </div>
                </div>

                <div className="border-l-4 border-[#4CAF50] pl-4">
                  <h4 className="font-bold text-gray-900 mb-2">IDS川副教習所</h4>
                  <p className="text-sm text-gray-600 mb-2">九三エンジニアリング株式会社</p>
                  <p className="text-sm text-gray-600 mb-2">対応エリア：佐賀県佐賀市周辺</p>
                  <div className="flex items-center mb-1">
                    <i className="ri-phone-line mr-2 text-[#4CAF50]"></i>
                    <a href="tel:0952-97-5291" className="text-lg font-bold text-[#4CAF50] hover:text-[#45a049] cursor-pointer">
                      0952-97-5291
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-mail-line mr-2 text-gray-400"></i>
                    <a href="mailto:kawasoe@ids-group.jp" className="text-sm text-gray-600 hover:text-[#4CAF50] cursor-pointer">
                      kawasoe@ids-group.jp
                    </a>
                  </div>
                </div>

                <div className="border-l-4 border-[#4CAF50] pl-4">
                  <h4 className="font-bold text-gray-900 mb-2">IDS鹿児島教習所</h4>
                  <p className="text-sm text-gray-600 mb-2">株式会社エコナーセリー</p>
                  <p className="text-sm text-gray-600 mb-2">対応エリア：鹿児島県全域</p>
                  <div className="flex items-center mb-1">
                    <i className="ri-phone-line mr-2 text-[#4CAF50]"></i>
                    <a href="tel:099-213-9466" className="text-lg font-bold text-[#4CAF50] hover:text-[#45a049] cursor-pointer">
                      099-213-9466
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-mail-line mr-2 text-gray-400"></i>
                    <a href="mailto:kagoshima@ids-group.jp" className="text-sm text-gray-600 hover:text-[#4CAF50] cursor-pointer">
                      kagoshima@ids-group.jp
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#4CAF50]/5 border border-[#4CAF50]/20 rounded-2xl p-6">
              <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                <i className="ri-information-line text-[#4CAF50] mr-2"></i>
                無料現地調査実施中
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed">
                圃場の状況確認、散布方法のご提案、正確なお見積りのため、無料で現地調査を実施しています。
                お気軽にご依頼ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}